export const TEXT_CONTAINER_WIDTH = '700px'